const Constants = {
	ENV: process.env.VUE_APP_ENVIRONMENT,
	HH_COMPONENTS_URL: process.env.VUE_APP_HH_COMPONENTS_URL,
	EMPLOYEE_HUB_GUIDES_API_BASE_URL:
		process.env.VUE_APP_EMPLOYEE_HUB_GUIDES_API_BASE_URL,
	EMPLOYEE_HUB_SUPPLIER_API_BASE_URL:
		process.env.VUE_APP_EMPLOYEE_HUB_SUPPLIER_API_BASE_URL,
	EMPLOYEE_HUB_USER_MANAGEMENT_BASE_URL: process.env.VUE_APP_EMPLOYEE_HUB_USER_MANAGEMENT_BASE_URL,
	EMPLOYEE_HUB_API_BASE_URL: process.env.VUE_APP_EMPLOYEE_HUB_API_BASE_URL,
	EMPLOYEE_HUB_HEADLESS_API_BASE_URL:
		process.env.VUE_APP_EMPLOYEE_HUB_HEADLESS_API_BASE_URL,
	EMPLOYEE_HUB_SERVICE_NOW_API_BASE_URL: process.env.VUE_APP_SERVICE_NOW_API_URL,
	SERVERLESS_HUB_API_API_BASE_URL: process.env.VUE_APP_SERVERLESS_HUB_API_BASE_URL,
	MAX_RETRY_COUNT: 2,
	SUPPLIER_CENTRAL_URL: process.env.VUE_APP_EH_URL + '/apps/supplier-central/supplier-guide',
	JUMP_LINKS_URL: '/apps/supplier-central/supplier-guide#',
	RETRY_INTERVAL_IN_MILLIS: 2000,
	CREDIT_MEMO_PRESENT: 'X',
	DATE_ALL_ZEROS: '0000-00-00',
	ALLOWED_CHANNEL_FOR_COPY: 'EMPHUB_WEB',
	ERROR_MESSAGE:
		"There was an error that wasn’t your fault. Go get a cup of coffee, come back, and try again later or contact support.",
	ONE_INTAKE_ERROR_MESSAGE : "An error occurred that wasn’t your fault. An IT incident ticket has been created for it. The Supplier Central request will be created on your behalf, and you will receive an email confirmation upon completion. You will also find the request on My Supplier Requests page once the issue has been resolved",
	NO_RECORDS_FOUND_MESSAGE: "There are no existing records for ",
	EH_URL: process.env.VUE_APP_EH_URL,
	EH_BASE_URL: "https://employeehub.autodesk.com",
	LOCAL_EMPLOYEE_HUB_API_URL:
		"https://api.dev.emphub-dev.autodesk.com/guidesmanagement",
	DEV_EMPLOYEE_HUB_API_URL:
		"https://api.dev.emphub-dev.autodesk.com/guidesmanagement",
	QA_EMPLOYEE_HUB_API_URL:
		"https://api.qa.emphub-dev.autodesk.com/guidesmanagement",
	TEST_EMPLOYEE_HUB_API_URL:
		"https://api.test.emphub.autodesk.com/guidesmanagement",
	PRD_EMPLOYEE_HUB_API_URL: "https://api.emphub.autodesk.com/guidesmanagement",
	SUPPORT_URL: "/support",
	GENERIC_SERVICE_TICKET_CATEGORY: "95844bb113577240df4573076144b0b2",
	INCIDENT_TICKET_CATEGORY: "3c6483f113577240df4573076144b0df",
	SEARCH_URL: "/search-results",
	DEV_MIXPANEL_TOKEN: "cef2430fd2b120a9ca79892927965ebc",
	QA_MIXPANEL_TOKEN: "cef2430fd2b120a9ca79892927965ebc", // Same as dev
	TEST_MIXPANEL_TOKEN: "4ea0a3a89003570ec8ea178329c79880",
	PRD_MIXPANEL_TOKEN: "f4e11a20e7892182b82a59c7a2dec2d1",
	PTP_REDIRECT_URL: process.env.VUE_APP_FAST_TRACK_URL,
	GUIDES_ALIAS: "supplier-guide",
	INVOICES_ROUTE: "/invoice-dashboard",
	PURCHASE_ORDERS_ROUTE: "/purchase-orders",
	PAGINATION_THRESHOLD: 10,
	PAGINATION_THRESHOLD_FIVE: 5,
	NO_SUPPLIERS_MESSAGE: "Sorry, we can't find any suppliers.",
	NO_PRODUCTS_MESSAGE: "Sorry, we can't find any products or services.",
	EH_PURCHASE_INSTRUCTIONS_URL:
		"ptp/articles/a66fd1c58739e990c430b808cebb35d3",
	STALEMATE_STATUS: "stalemate",
	COMPLAINT_NO_PERSONAL_DATA_STATUS: "Compliant-no personal data",
	PURCHASING_INSTRUCTIONS_NEXT_STEPS: "Purchasing instructions",
	SOFTWARE_PURCHASE_REQUEST_FORM : "Software purchase request form",
	CLICK_HERE_FOR_ACCESS:"Click here for access",
	CLICK_HERE_TO_DOWNLOAD:"Click here to download",
	ENGAGE_WITH_SUPPLIER: "Engage with supplier",
	ENTERPRISE_SEARCH_API_URL: process.env.VUE_APP_ENTERPRISE_SEARCH_API_URL,
	FIELD_GLASS_URL: "https://www.fieldglass.net/SSOLogin?TARGET=company%3DADSK",
	REJECTED_STATUS: "Rejected by AP",
	SAP_LINE_SEPARATOR: "<NextLine>",
	SUPPLIER_PORTAL_HELP: {
		EMAIL: 'mailto:supplier_portal_help@autodesk.com',
		SLACK: 'https://autodesk.slack.com/archives/C01V3R8MSDT'
	},
	DELETE_DRAFT_ERROR_MESSAGE: 'There was an error while deleting the draft. Please try again or contact support.',
	BOLETO_COMPANY_CODE: '3620',
	VGT_PAGINATION_EXPLICIT_WAIT_IN_MILLIS: 600,
	SHOW_BANK_ACCOUNT_TYPE_COUNTRIES: [
		"Japan",
		"Argentina",
		"Brazil",
		"Colombia",
	],
	SUPPLIER_CENTRAL_ADMIN_ROLE: 'SUPPLIER_CENTRAL_ADMIN',
	FINANCIAL_SERVICES_DEPARTMENT: "Finance-Financial Services",
	WORKPLACE_AND_TRAVEL_DEPARTMENT: "PPL-Workplace & Travel",
	ALLOW_ALL_DEPARTMENTS: 'ALLOW_ALL_DEPARTMENTS',
	ERROR_MESSAGE_TYPE: "E",
	SUCCESS_MESSAGE_TYPE: "S",
	INDIA_COMPANY_CODE: "1700",
	EMPLOYEE_HUB_SUPPLIER: "employeehub-supplier",
	FILE_NAMING_BAD_SYMBOL_LIST: [
		"\\",
		":",
		"*",
		"?",
		'"',
		"/",
		">",
		"<",
		"|",
	],
	FILE_NAMING_ALLOWED_SYMBOLS_MESSAGE:
		" .Please use symbols except \\ / : * ? \" < > | ",
	ERROR_BAD_FILENAME_SYMBOL: "Invalid symbols for filename  ",
	MAX_ALLOWED_INVOICE_ITEMS: 40,
	PAYMENT_DATE_FIELD: "paymentDate",
	INVOICE_STATUS_FIELD: "invoiceStatus",
	TAX_FIELDS: ["TI", "TD"],
	ONE_TIME_SUPPLIER_PAYMENT: "OneTimeSupplierPayment",
	NON_PO_PAYMENT_FORM: "NonPOBasedPayment",
	PO_BASED_PAYMENT_FORM: "POBasedPayment",
	INVOICE_FORM_TYPE: [
		{
			formCode:"PMTREQFORM",
			eligibleFormTypes:["POBasedPayment","DraftPOBasedPaymentForm","CopyPOBasedPaymentForm"],
			formDisplayText: "Purchase order without an invoice"
		},
		{
			formCode:"NPOFORM",
			eligibleFormTypes:["NonPOBasedPayment","DraftNonPOBasedPaymentForm","CopyNonPOBasedPaymentForm"],
			formDisplayText: "Non purchase order invoice"
		},
		{
			formCode:"OTVFORM",
			eligibleFormTypes:["OneTimeSupplierPayment","DraftOneTimeSupplierPayment"],
			formDisplayText: "One time supplier invoice"
		},
		{
			formCode:"ADVPMTFORM",
			eligibleFormTypes:["AdvancePOBasedPayment","DraftAdvancePOBasedPayment"],
			formDisplayText: "Advanced purchase order invoice"
		},
		{
			formCode:"PO",
			eligibleFormTypes:["InvoiceSubmission","DraftInvoiceSubmission"],
			formDisplayText: "Invoice/Credit Memo"
		},
	],
	MY_SUPPLIER_REQUESTS_TAB_ROUTES : {
		ALL_REQUESTS : 'all-requests',
		DRAFT_REQUESTS : 'draft-requests',
		RETURNED_REQUESTS: 'returned-requests',
		RECENTLY_SUBMITTED_REQUESTS : 'recently-submitted-requests',
		COMPLETED_REQUESTS : 'completed-requests'
	},
	INVOICES_TAB_ROUTES: {
		ALL_INVOICES : 'all-invoices',
		INVOICES : 'invoices',
		SUBMITTED_INVOICES : 'recently-submitted-invoices',
		DRAFTS: 'draft-invoices'
	},
	DRAFT_PO_BASED_PAYMENT_FORM: "DraftPOBasedPaymentForm",
	COPY_PO_BASED_PAYMENT_FORM: "CopyPOBasedPaymentForm",
	COPY_NON_PO_BASED_PAYMENT_FORM: "CopyNonPOBasedPaymentForm",
	DRAFT_NON_PO_BASED_PAYMENT_FORM: "DraftNonPOBasedPaymentForm",
	DRAFT_ONE_TIME_SUPPLIER_PAYMENT_FORM: "DraftOneTimeSupplierPayment",
	ADV_PO_BASED_PAYMENT_FORM: "AdvancePOBasedPayment",
	INVOICE_SUBMISSION_FORM: "InvoiceSubmission",
	EXCEPTION_SUBMISSION_FORM: "ExceptionSubmissionRequest",
	INVOICES_TABLE_ROUTE: 'Invoices',
	INVOICES_COMPONENT_TITLE_HEADER: 'Invoices',
	PURCHASE_ORDERS_COMPONENT_TITLE_HEADER: "Purchase orders",
	DRAFT_DASHBOARD_OPTIONAL_ROUTE: '/invoice-dashboard/draft-invoices',
	INVOICE_SUBMISSION_TRACKER_OPTIONAL_ROUTE: '/invoice-dashboard/recently-submitted-invoices',
	WORKING_WITH_SUPPLIER_ROUTE: '/working-with-supplier',
	PAYMENT_TYPES_ROUTE: "/payment-types",
	PURCHASE_ORDERS_TABLE_ROUTE: 'PurchaseOrders',
	ONE_TIME_SUPPLIER_API_FORM_TYPE: "OTVFORM",
	PO_BASED_API_FORM_TYPE: "PMTREQFORM",
	NON_PO_BASED_API_FORM_TYPE: "NPOFORM",
	ADV_PO_BASED_API_FORM_TYPE: "ADVPMTFORM",
	INVOICE_SUBMISSION_BASED_API_FORM_TYPE: "PO",
	FILE_NAME_TRUNCATE_LENGTH: 105,
	MULTI_INVOICES_ERROR_MESSAGE: "Invoice details are required.",
	MULTI_INVOICE_COMPANY_CODE_CURRENCY_REQUIRED:
		"Please enter currency and company code in the questions above.",
	ATTACHMENTS_MAX_SIZE_IN_MB:{
		ONE_INTAKE_FORM:7,
		INVOICE_PAYMENT_FORMS : 5
	},
	INVOICE_SUBMISSION_RESPONSE_MSG_PREFIX_LENGTH: 23,
	ACCOUNTS_PAYABLE_SLACK: "https://autodesk.slack.com/app_redirect?app=A02QRD6227M",
	LUMI_SLACK : "https://autodesk.slack.com/app_redirect?app=A02QRD6227M",
	ACCOUNTS_PAYABLE_FAQ: "https://employeehub.autodesk.com/PTP/articles/3d14e21e1bb718501a22ba651a4bcb2b",
	POSITIVE_WITH_DECIMAL_AND_COMMAS: "^(?:[0-9]+,)*[0-9]+(?:\\.[0-9]+)?|^\\s|^$",
	POSITIVE_OR_NEGATIVE_WITH_DECIMAL_AND_COMMAS:
		"^[-+]?(?:[0-9]+,)*[0-9]+(?:\\.[0-9]+)?$",
	ARIBA_REROUTE_URL:
		"https://s1.ariba.com/gb/landingPage?id=AMER_3000_non-catalogs&realm=autodesk&realm=autodesk&locale=en_US",
	FOOTER_FAQ_URL: "https://employeehub.autodesk.com/IT/articles/e0fab63fdbf8ac14530241fb0b9619a4",
	PROCUREMENT_TEAM_SLACK_URL: "https://autodesk.slack.com/archives/CCVM8BMNH",
	SUPPLIER_CENTRAL_SLACK_URL: "https://autodesk.slack.com/archives/C01CJQQGFB9",
	CORPORATE_TEAM_SLACK_URL: "https://autodesk.slack.com/archives/C9BHKCMSB",
	INVOICE_UPLOAD_FILE_CONVERSION: "https://wiki.autodesk.com/pages/viewpage.action?pageId=1362022929",
	NEW_RESELLER_MAIL: "sourcinghub@autodesk.com",
	ADMIN_AP_VIEW_TITLE:"ACCOUNTS PAYABLE ADMIN VIEW",
	LOCALHOST_URL: "localhost:8080",
	PROCUREMENT_TECHNOLOGY_OPTION : "Technology",
	SUPPLIER_REQUIRES_SOW : ["AMC BRIDGE LLC"],
	AMC_SOW_URL : "https://apps.powerapps.com/play/e/e66521ab-1f84-4d73-b483-68b8472f9718/a/06963550-d76c-4b74-b0cb-15cee86a164c?Supplier=AMCBridge",
	ONE_INTAKE_RADIO_BOOLEAN:[
		{id: "0", value: true, text:"Yes",displayText:"Yes"},
		{id: "1", value: false, text: "No",displayText: "No"},
	],
	ONE_INTAKE_SUPPLIER_LOCATED_RADIO_OPTIONS:[
		{id: "0", text:"US", displayText:"us"},
		{id: "1", text: "UK", displayText: "uk"},
		{id: "2", text: "Canada", displayText: "canada"},
		{id: "3", text: "Other", displayText: "other"}
	],
	ONE_INTAKE_RADIO_BOOLEAN_EMPLOYEE:[
		{id: "0", value: true, text:"fewer than five full time employees",displayText:"Yes"},
		{id: "1", value: false, text: "five or more full time employees",displayText: "No"},
	],
	ONE_INTAKE_RADIO_OPTIONS: [
		{id: "0", text: "yes", value : "Yes",displayText:"Yes"},
		{id: "1", text: "no", value : "No" , displayText: "No"},
		{id: "2",text: "don't know", value : "Don't know", displayText: "I don't know"}
	],
	ONE_INTAKE_LISCENCE_INSTALLED_RADIO_OPTIONS: [
		{id: "0", text: "yes",displayText:"Yes"},
		{id: "1", text: "no", displayText: "No"},
		{id: "2",text: "not a software purchase", displayText: "This is not a software purchase"},
	],
	ONE_INTAKE_PERSONAL_DATA_OPTIONS: [
		{id: "0", text: "autodesk customer data",displayText:"Autodesk customer data"},
		{id: "1", text: "autodesk employee data", displayText: "Autodesk employee data"},
		{id: "2",text: "autodesk customer and employee data", displayText: "Autodesk customer and employee data"}
	],
	APPROXIMATE_SPEND_VALUE: 5000,
	FILE_TYPES: {
			extensionAsPdf:{
				validFileTypes:".pdf"
			},
			extensionAsAll:{
				validFileTypes:".pdf,.png,.jpeg,.jpg,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
			}
	},
	ATTACH_A_SUPPORTING_DOC : "Attach a supporting document",
	ATTACH_AN_INVOICE : "Attach an invoice",
	ATTACH_DOCUMENT_TOOLTIP: "Supporting documentation could include an order form, agreement, proposal, statement of work, etc.",
	APPROXIMATE_SPEND_TOOLTIP: "All approximated cost is in USD. Enter Numbers only, no commas, no decimals, no local currency.",
	PROFESSIONAL_SERVICES_TOOLTIP:"You are receiving this question because you answered ‘yes’ to question 14.",
	SUPPLIER_NAME_TOOLTIP:"If you are buying software through a value-added reseller, please include the name and information related to the manufacturer, not the reseller.",
	RESELLER_NAME_TOOLTIP:"Reseller name is to be selected from the dropdown",
	SUPPLIER_ONBOARDING_TRACKER: {
		TITLE: "Supplier setup status",
		APEX_TOOLTIP: "Represents onboarding status of a supplier. New suppliers are invited to register by providing their banking and payment details through Autodesk’s supplier portal. Once they’ve completed registration and your ticket Is fully approved, you can find their SAP ID in the ‘Supplier setup status’ column below.",
		TOOLTIP: "Represents onboarding status of a supplier via supplier portal. If you have selected as paying by corporate card, purchasing via reseller, or approximate spend amount as 0, this status shall not be applicable (N/A)"
	},
	ATTACHMENT_VALIDATION_ERROR_MESSAGE: {
		ZERO_KB_ERROR: "A file you selected is of size 0kb. Please select files greater than of size 0kb",
		INVALID_FILE_EXTENSION_ERROR: "Invalid file type selected. Valid file types:",
		FILE_NAME_50_CHAR_ERROR: "Files uploaded should have names less than 50 chars",
		ALREADY_EXIST_ERROR: "A file you selected already exists.",
		FILE_SIZE_EXCEEDED_ERROR: "Total allowed file size exceeded"
	},
	SUPPLIER_EMAIL_SUPPORT: [
		{
			EMAIL_TEXT: 'AMER',
			EMAIL_VALUE: 'amer.vendor.master.inquiries@autodesk.com'
		},
		{
			EMAIL_TEXT: 'EMEA',
			EMAIL_VALUE: 'emea.vendor.master.inquiries@autodesk.com'
		},
		{
			EMAIL_TEXT: 'APAC',
			EMAIL_VALUE: 'apac.vendor.master.inquiries@autodesk.com'
		}
	],
	PPLUS_DATA_CLEAN_UP: "(PPLUS)",
	MAXIMUM_AMOUNT_CHAR_LENGTH: 16,
	PO_NUMBER_MAX_LENGTH: 10,
	SUPPLIER_ID_MAX_LENGTH: 6,
	POPOVER_HIDE_TIMEOUT_IN_MILLIS: 300,
	MODE_OF_PAYMENT: {
		BANK_TRANSFER: "bankTransfer",
		DIRECT_DEBIT: "directDebit",
		CITI_DIRECT_PAYMENT: "citiDirectPayment",
		BOLETO: "boleto"
	},
	INVOICE_MODAL_PARAMS: {
		INVOICE_NUMBER_FIELD: "invoiceNumber",
		DOC_ID_FIELD: "docId",
	},
	FY_BOUNDS:{
		LOWER_BOUND: "February",
		UPPER_BOUND: "January",
		TOTAL_MONTHS_OF_VIEWABLE_DATA : 18
	},
	FORM_ROUTE_MAP: [
		{
			currentForm: "NonPOBasedPayment",
			formName: "nonPOPaymentData",
			resetFormMethod: "resetNonPOPaymentData",
		},
		{
			currentForm: "DraftNonPOBasedPaymentForm",
			formName: "nonPOPaymentData",
			resetFormMethod: "resetNonPOPaymentData",
		},
		{
			currentForm: "CopyNonPOBasedPaymentForm",
			formName: "nonPOPaymentData",
			resetFormMethod: "resetNonPOPaymentData",
		},
		{
			currentForm: "DraftPOBasedPaymentForm",
			formName: "poBasedPaymentData",
			resetFormMethod: "resetPOBasedPaymentData",
		},
		{
			currentForm: "CopyPOBasedPaymentForm",
			formName: "poBasedPaymentData",
			resetFormMethod: "resetPOBasedPaymentData",
		},
		{
			currentForm: "OneTimeSupplierPayment",
			formName: "oneTimeSupplierPayment",
			resetFormMethod: "resetOneTimeSupplierPaymentData",
		},
		{
			currentForm: "DraftOneTimeSupplierPayment",
			formName: "oneTimeSupplierPayment",
			resetFormMethod: "resetOneTimeSupplierPaymentData",
		},
		{
			currentForm: "POBasedPayment",
			formName: "poBasedPaymentData",
			resetFormMethod: "resetPOBasedPaymentData",
		},
		{
			currentForm: "AdvancePOBasedPayment",
			formName: "advPOBasedPayment",
			resetFormMethod: "resetAdvPOBasedPaymentData",
		},
		{
			currentForm: "InvoiceSubmission",
			formName: "invoiceSubmissionData",
			resetFormMethod: "resetInvoiceSubmissionData",
		},
	],
	oneIntakeCountryCodeCheckBoxes: [
		"3500",
		"1330",
		"1320",
		"2060",
		"1700",
		"2006",
		"1100",
		"1000",
		"2080",
		"2040",
		"3000",
	],
	// Will need to be updated for every new country added
	oneIntakeAllCountryData: [
		{
			threshold: 24999,
			isEligibleForFastTrack : true,
			costCenter: "1000",
			geo: "APAC"

		},{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2081",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2072",
			geo: "EMEA"
		},
		{
			threshold: 24999,
			isEligibleForFastTrack : true,
			costCenter: "1200",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "3500",
			geo: "AMER"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack: false,
			costCenter: "1330",
			geo: "APAC"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack : false,
			costCenter: "1320",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2060",
			geo: "EMEA"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack : false,
			costCenter: "1700",
			geo:"APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2006",
			geo:"EMEA"
		},
		{
			threshold: 14999,
			isEligibleForFastTrack : false,
			costCenter: "1100",
			geo:"APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2080",
			geo:"EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2040",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "3000",
			geo: "AMER"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "3610",
			geo: "AMER"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2010",
			geo:"EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2025",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "3620",
			geo: "AMER"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "3650",
			geo: "AMER"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "3670",
			geo: "AMER"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2071",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2030",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2936",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2093",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2050",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "1400",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2160",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2210",
			geo:"EMEA"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack : false,
			costCenter: "1003",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2130",
			geo:"EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2911",
			geo:"EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2070",
			geo:"EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2043",
			geo:"EMEA"
		},
		{
			threshold: 14999,
			isEligibleForFastTrack : false,
			costCenter: "1800",
			geo:"APAC"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack : false,
			costCenter: "1001",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "3600",
			geo: "AMER"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "3660",
			geo: "AMER"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2020",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2240",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2150",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2092",
			geo: "EMEA"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack : false,
			costCenter: "1004",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2170",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2106",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2921",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2190",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2935",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2104",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2090",
			geo: "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2100",
			geo: "EMEA"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack : false,
			costCenter: "1600",
			geo: "APAC"
		},
		{
			threshold: 4999,
			isEligibleForFastTrack : false,
			costCenter: "1002",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2180",
			geo : "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "2042",
			geo: "APAC"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : true,
			costCenter: "2250",
			geo : "EMEA"
		},
		{
			threshold: 49999,
			isEligibleForFastTrack : false,
			costCenter: "1005",
			geo :"APAC"
		}
	],
	FAST_TRACK_VALUE: 'fast_track',
	ARIBA_VALUE : 'ariba',
	IC_VALUE: 'Independent Contractor',
	SUPPLIER_CENTRAL_VALUE: 'supplier_central',
	MINIMUM_CHAR_LENGTH_FOR_AUTOCOMPLETE: 1,
	MAXIMUM_CHAR_LENGTH_FOR_AUTOCOMPLETE: 34,
	SUPPLIER_NAME_THRESHOLD : 90,
	CORE_COMPANY_API : {
		BASE_QUERY: '/api/now/table/core_company?sysparm_query=u_supplier_sourceINexternal portal,ivy vendor,sap,supplier central^u_master_record_onboarding_status=completed^nameNOT%20LIKE**',
		BASE_QUERY_AUTOCOMPLETE: '/api/now/table/core_company?sysparm_query=u_supplier_source=supplier central^u_technology_reseller!=true^u_master_record_onboarding_status=completed^nameNOT%20LIKE**',
		ONBOARDING_STATUS_BASE_QUERY: '/api/now/table/core_company?sysparm_query=',
		SYS_PARAMS: '&sysparm_fields=sys_id,name,u_vendor_parent,u_company_website,u_vendor_id,u_status,u_supplier_central_ritm,u_vendor_id',
	},
	SUPPLIER_NAMES_FILE_NAME :'supplier-names.csv',
	SUPPLIER_COUNTRY_QUERY: `/api/now/table/u_gdpr_country_matrix?sysparm_fields=u_country`,
	AGENT_STATUS_API_QUERY: `/api/now/table/sc_req_item?sysparm_fields=u_agent_status,u_agent_work_notes,assigned_to.user_name,short_description`,
	PARENT_CASE_STATUS_API_QUERY: `/api/now/table/sc_req_item?sysparm_fields=sys_created_by,sys_created_on,u_state,state,short_description,u_request_exit_point&sysparm_display_value=true`,
	SERVICENOW_USERS_QUERY: `/api/now/table/sys_user?sysparm_fields=u_display_name,user_name,sys_id`,
	QUESTIONNAIRE_DATA: '/api/now/table/u_adsk_vendor_onboarding',
	EN_US_LOCALE: 'en-US',
	AGENT_STATUS_MAP: {
		"0":"Not applicable",
		"1":"Open",
		"2":"Work in progress",
		"3":"Stalemate (Unable to reach agreement)",
		"4":"Cancelled",
		"5":"Waiting on business",
		"11":"Waiting on supplier",
		"18":"Completed"
	},
	SUPPLIER_ENGAGEMENT_SHORT_DESC: 'Supplier engagement request',
	EMAIL_CHARACTER: '@',
	SERVICE_NOW_CASE_STATUS_MAP: {
		OPEN: "Open",
		WORK_IN_PROGRESS: "Work in progress",
		PENDING_APPROVAL: "Pending approval",
		CLOSED: "Closed",
		RESOLVED_COMPLETE: "Resolved complete",
		RESOLVED_INCOMPLETE: "Resolved incomplete",
		RESOLVED_INCOMPLETE_STATE: "4",
		CANCELLED_OVERRIDE: 'Cancelled'
	},
	MONTHS_WORTH_OF_DASHBOARD_DATA: 9,
	NAV_BANNER_MESSAGE: {
		showMessage: false,
		text: 'Note: Due to the global supply chain issue, delivery of all hardware parts and devices may take up to several months. If you have any questions, please post to the <a href="https://autodesk.slack.com/archives/CHW1M442K" target="_blank" style="text-decoration: underline;font-family: artifaktElementBold">Slack channel</a>.',
		isWarning: false
	},
	//retry for submission status every 5 seconds for 24 times = 2mins
	//This is in sync with api timeout configured on asyncHandler.
	WEBFORM_SUBMISSION_POLLING: {
		RETRY_INTERVAL: 5000,
		RETRY_COUNT: 24
	},
	WEBFORM_SUBMISSION_STATUS: {
		FAILED: "failed",
		PUBLISHED: "published",
		SUBMITTED: "submitted"
	},
	PTP_ARTICLE_URL: "https://employeehub.autodesk.com/PTP/articles/87788c931bbf10901a22ba651a4bcb17",
	INTERACTING_WITH_AUTODESK_CUSTOMERS:`This question refers to direct interaction with customers or prospective customers for the purpose of, for example, selling, marketing, explaining, or auditing Autodesk products or services. It does not include engagements with only indirect contact with customers, such as code development, solution design, or marketing development integrated into our products or services.`,
	MIXPANEL_API_FAILURE: {
		SERVICE_NOW_CORE_COMPANY_API_FAILURE: "SERVICE_NOW_CORE_COMPANY_API_FAILURE",
		SERVICE_NOW_EXCEPTION_SUBMISSION_DRAFTS_FETCH_FAILURE: "SERVICE_NOW_EXCEPTION_SUBMISSION_DRAFTS_FETCH_FAILURE",
		SYS_ATTACHMENTS_API_FAILURE: "SYS_ATTACHMENTS_API_FAILURE",
		SYS_USER_API_FAILURE: "SYS_USER_API_FAILURE",
		VENDOR_ONBOARD_RECORD_CREATE_FAILURE: "VENDOR_ONBOARD_RECORD_CREATE_FAILURE"
	},
	ADSK_VENDOR_ONBOARD_STATUS: {
		DRAFT: "Draft",
		SUBMITTED: "Submitted"
	},
	SUPPLIER_DRAFT_FORM_TYPE: {
		ONE_INTAKE: "Supplier engagement",
		EXCEPTION_SUBMISSION: "Exception submission request"
	},
	EXCEPTION_SUBMISSION_REQUEST_FOR_MAP: {
		ADSK_CONSULTING_ENGAGEMENTS: "Autodesk Sales Consulting Engagements",
		SPONSORSHIP: "Sponsorship",
		CORPORATE_DONATION: "Corporate donation",
		SPEAKER: "Speaker",
		OTHER: "Other",
		RENT_UTILITIES: "Rent/utilities",
		LEGAL_SERVICES: "Legal services"
	},
	SUPPLIER_CENTRAL_CATEGORIES_EXCEPTIONS_LIST:["autodesk sales consulting engagements","sponsorship","corporate donation","rent/utilities","legal services"],
	ONE_INTAKE_FORM_REDIRECT_SELECTION: "",
	SSO_LOGIN_APP_REGEX : /Zoom|Mural/,
	CLICK_HERE_FOR_ACCESS_APP_REGEX: /Denodo Platform|Looker Data Sciences Enterprise|Port Swigger|Syntevo SmartGit/,
	CLICK_HERE_TO_DOWNLOAD_REGEX: /Azul/,
	SSO_LOGIN_TEXT : "SSO Login",
	CORPORATE_CARD_HELP_LINKS:{
		TYPE1: "<a href='https://one.autodesk.com/PTP/articles/4c963a2d1b560514c516cae5604bcb98' target='_blank'>please click here for more details</a>",
		TYPE2: "<a href='https://one.autodesk.com/PTP/articles/b2f178e71befdd90c516cae5604bcb06' target='_blank'>please click here for more details</a>",
		TYPE3: "<a href='https://one.autodesk.com/PTP/articles/87788c931bbf10901a22ba651a4bcb17' target='_blank'>please click here for more details</a>"
	},
	CHILD_CASE_TOOLTIP:{
		"Privacy Addendum (DUPA)":"The Privacy Addendum is required if the supplier engagement involves <a href='https://one.autodesk.com/LEGAL-MARKETING-TOOLKIT/articles/25afe5851b13c1d024ff64e8624bcb44' target='_blank'>processing of personal data.</a> This task will ensure the supplier meets privacy contract requirements.",
		"Privacy Delete Method":"The Privacy Delete Method is required if the supplier engagement involves the processing of personal data. This ticket will ensure the personal data delete procedures are appropriately documented. The Privacy Delete Method does not require completion prior to the other onboarding tasks (contract signature, supplier setup, Ariba purchase request/PO creation, etc.) ",
		"Product Legal Engagement":"Legal engagement is required when a supplier will be developing or accessing Autodesk code. In this stage, an assigned product attorney will review the request. ",
		"Vendor Legal Compliance Check":"Autodesk requires a compliance check when the request involves: <br> 1.	A new supplier (not recognized by the system)<br>2.	A supplier interacting with customers on Autodesk’s behalf<br>3.	A government agency or lobbying firm <br>4.	The use of a supplier with a personal relationship with the Autodesk business owner <br>These instances require a Vendor Legal Compliance Check and potentially special contract language.",
		"Sourcing Engagement":"The Sourcing team will help you select a supplier and ensure the right contract is in place with a new or existing supplier.",
		"Vendor Management Engagement":"Vendor Management teams are required to review engagements for Marketing, Technology, and PSET. ",
		"Supplier Certification and Setup":"The Supplier Certification team ensures the correct existing supplier is selected and new suppliers are properly set up for payment. Any new supplier (not recognized by the system) will be invited to provide their payment details in Autodesk’s Supplier Portal. Invitations to new suppliers are sent once Vendor Legal Compliance review is completed. This ticket does not need to be completed prior to signing the contract, but it must be complete prior to creating the Ariba request / purchase order.",
		"Security Assessment":"Security review is triggered when a supplier has data privacy impacts, network connections, and/or access to source code. If Security is engaged, the requestor/business owner will receive a Tiering Assessment from Security that must be completed to start their review process."
	},
	APEX_CHILD_TASK:"Supplier Certification and Setup",
	GENERATIVE_AI : {
		GENERATIVE_AI_SLACK_URL : "https://autodesk.slack.com/archives/C0KBT3859",
		GENERATIVE_AI_LEGAL_ARTICLE :'https://one.autodesk.com/LEGAL/articles/6ce6f4001b51e5d0c987a9f5624bcb32',
		GENERATIVE_AI_CREATE_RECORD_ARTICLE : 'https://one.autodesk.com/apps/cms/generative-ai/create-record/generative-ai'
	},
	FEEDBACK_TIMEOUT_IN_MILLIS : 3000,
	//Error Payload  Details
	ERROR_PAYLOAD_FIELD_NAMES : {
		STATUS : "status",
		HOST : "host",
		CHECK : "check",
		ALERT_ENVIRONMENT : "alertEnvironment",
		DESTINATION : "destination",
		SUB_CATEGORY : "subCategory",
		CATEGORY : "category",
		SEVERITY : "severity",
		EVENT_DETAIL : "eventDetail",
		SHORT_DESCRIPTION : "shortDescription",
		SLACK : "slack",
		EMAIL : "email",
		CONFIGURATION_ITEM : "configurationItem",
		PARTITION_KEY : "partitionKey",
		CALLER : "caller",
		SERVICE_ID : "serviceId",
		SERVICE_NAME : "serviceName"
	},
	ERROR_PAYLOAD_VALUES_FOR_ONE_INTAKE : {
		STATUS : "critical",
		HOST : "APPLICATION",
		CHECK : "SUPPLIER_CENTRAL_ONE_INTAKE",
		ALERT_ENVIRONMENT : process.env.VUE_APP_ENVIRONMENT == "qa" || process.env.VUE_APP_ENVIRONMENT == "prd" ? process.env.VUE_APP_ENVIRONMENT.toLowerCase() : "dev",
		DESTINATION : "bigpanda,snow,email,slack",
		SUB_CATEGORY : "Supplier Portal",
		CATEGORY : "monitoring",
		SEVERITY : "5",
		SLACK : "#vendorportaldevteam",
		EMAIL: "ESE.EDC.SupplierPortal.Dev.Team@autodesk.com",
		CONFIGURATION_ITEM : "u_enterprise_applications__Supplier Portal",
		PARTITION_KEY : "SUPPLIER_CENTRAL_ALERT",
		CALLER : "bigpanda",
		SERVICE_ID : "1F6CE4B2",
		SERVICE_NAME : "Supplier Portal"
	},

	SHORT_DESCRIPTION : "SHORT_DESCRIPTION",
	EVENT_DETAIL : "EVENT_DETAIL",
	IS_SUPPLIER_CENTRAL_DOWN: false,
	MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN : "",
	PROCUREMENT_DOCUMENT_IC_URL_US : "https://one.autodesk.com/PTP/articles/12767#ICFieldglass",
	PROCUREMENT_DOCUMENT_IC_URL_CANADA : "https://one.autodesk.com/PTP/articles/14737#ICFieldglass",
	PROCUREMENT_DOCUMENT_IC_URL_UK : "https://one.autodesk.com/PTP/articles/13516#ICUK",
	IC_COUNTRIES: ["US", "UK", "Canada"],
	warningMessageForICDisabledQuestions: 'This question does not require an answer at this time, as the supplier has been recognized as an Independent Contractor.',
	SPINNER_URL : process.env.VUE_APP_HH_COMPONENTS_URL + "/spinner.svg"
};
export default Constants;
